<template>
  <div>
    <vx-card title="Tambah Data" subtitle="Isi data dengan benar">
      <template slot="actions">
          <div class="vx-row">
            <div class="vx-col w-full m-0">
              <vs-button icon-pack="feather" class="mt-2" @click="saveCashBookTemporary()">Simpan Data</vs-button>
              <vs-button to="/cash-book" class="ml-4 mt-2" type="border" color="danger">Batal</vs-button>
            </div>
          </div>
      </template>
      <div slot="no-body" class="p-6">
          <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="w-full mt-4">
                <label class="text-sm opacity-75">Jenis Kas</label>
                <ul class="centerx vx-row">
                  <li class="m-3">
                    <vs-radio vs-value="debit" v-model="type">Kas Masuk</vs-radio>
                  </li>
                  <li class="m-3">
                    <vs-radio vs-value="credit" v-model="type">Kas Keluar</vs-radio>
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="w-full mt-4">
                <label class="text-sm opacity-75">Tanggal</label>
                <vs-input class="w-full" v-mask="'##-##-####'" v-model="date" v-validate="'required'" name="date" />
                <span class="text-danger text-sm"  v-show="errors.has('date')">{{ errors.first('date') }}</span>
              </div>
            </div>
            <!-- <div class="vx-col md:w-1/2 w-full">
              <vs-input class="w-full mt-4" label="Nomor" v-model="number" v-validate="'required|numeric'" name="number" />
              <span class="text-danger text-sm"  v-show="errors.has('number')">{{ errors.first('number') }}</span>
            </div> -->
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Dibayarkan kepada</label>
              <vs-input class="w-full" v-model="paidTo" v-validate="'required'" name="paidTo" />
              <span class="text-danger text-sm"  v-show="errors.has('paidTo')">{{ errors.first('paidTo') }}</span>
            </div>
            <!-- <div class="vx-col w-full">
              <label class="text-sm opacity-75">Jumlah</label>
              <vs-input class="w-full" v-model="amount" v-validate="'required'" name="amount" />
              <span class="text-danger text-sm"  v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
            </div> -->
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Catatan</label>
              <vs-textarea class="w-full" v-model="notes" v-validate="'required'" name="notes" />
              <span class="text-danger text-sm"  v-show="errors.has('notes')">{{ errors.first('notes') }}</span>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <vs-row class="mt-4">
            <vs-col class="px-1" vs-sm="12" vs-lg="7">
              <label class="text-sm opacity-75">Keterangan</label>
            </vs-col>
            <vs-col vs-sm="12" vs-lg="5">
              <vs-row>
                <vs-col class="px-1" vs-sm="12" vs-lg="10">
                  <label class="text-sm opacity-75">Total</label>
                </vs-col>
                <vs-col class="px-1" vs-sm="12" vs-lg="2">
                  &nbsp;
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
          <template>
            <vs-row class="mb-2" v-for="(input, i) in inputs" :key="i">
                <vs-col class="px-1" vs-sm="12" vs-lg="7">
                  <vs-input
                    class="w-full"
                    v-model="input.title"
                    name="input.title"
                  />
                </vs-col>
                <vs-col vs-sm="12" vs-lg="5">
                  <vs-row>
                    <vs-col class="px-1 w-full md:w-10/12">
                      <vs-input
                        class="w-full"
                        v-model="input.amount"
                        v-money="money"
                        name="input.amount"
                      />
                    </vs-col>
                    <vs-col class="px-1" vs-sm="12" vs-lg="2">
                      <vs-button
                        class="w-full"
                        color="danger"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-trash"
                        @click="remove(i)"
                      ></vs-button>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
          </template>
          <div class="mt-4 px-1">
            <vs-button class="w-full" color="success" type="filled" icon-pack="feather" icon="icon-plus" @click="add()">Tambah</vs-button>
          </div>
          <div class="mt-4 px-1">
            Total : {{amount.toLocaleString()}}
          </div>
        </div>
      </div>
    </div>
  </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import { VMoney } from 'v-money'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// Store Module
import moduleCashBookTemporary from '@/store/cashbooks-temporary/moduleCashBookTemporary.js'

import { quillEditor } from 'vue-quill-editor'

const toolbarOptions = [
  ['bold', 'italic', 'underline'],        // toggled buttons

  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

  [{ 'font': [] }],
  [{ 'align': [] }]                                 // remove formatting button
]

export default {
  components: {
    vSelect,
    Datepicker,
    quillEditor
  },
  directives: { money: VMoney },
  data () {
    return {
      editorOption: {
        modules: {
          toolbar: toolbarOptions
        }
      },
      type: null,
      paidTo: null,
      date: null,
      balance: null,
      amount: 0,
      notes: null,
      inputs: [
        {
          title  : null,
          amount : null
        }
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      }
    }
  },
  created () {
    if (!moduleCashBookTemporary.isRegistered) {
      this.$store.registerModule('cashBookTemporary', moduleCashBookTemporary)
      moduleCashBookTemporary.isRegistered = true
    }
  },
  watch: {
    inputs: {
      handler (inputs) {
        this.amount = inputs
          .filter((input) => input.amount)
          .map((input) => parseInt(input.amount.replaceAll('.', '')))
          .reduce((prev, curr) => (prev += curr))
      },
      deep: true
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() &&
      this.type !== '' &&
      this.paidTo !== '' &&
      this.date !== ''  &&
      this.balance !== ''  &&
      this.amount !== null
    }
  },
  methods: {
    add () {
      this.inputs.push({
        title: null,
        amount: null
      })
    },
    remove (index) {
      this.inputs.splice(index, 1)
    },
    saveCashBookTemporary () {
      const self      = this

      this.$validator.validateAll().then(result => {
        if (result) {

          const formData = new FormData()
          formData.set('type', self.type)
          formData.set('paid_to', self.paidTo)
          formData.set('date_in', self.date)
          formData.set('balance', self.amount)
          formData.set('notes', self.notes)
          formData.append(
            'items',
            JSON.stringify(
              self.inputs.map((input) => {
                input.amount = input.amount.replaceAll('.', '')
                return input
              })
            )
          )
          this.$store.dispatch('cashBookTemporary/createCashBookTemporary', formData)
            .then(function () {
              self.$vs.notify({
                color: 'success',
                title: 'Berhasil',
                text: 'Bon Sementara berhasil di tambahkan'
              })
              self.$router.push('/cash-book-temporary')
            })
            .catch(err => {
              self.$vs.notify({
                color: 'danger',
                title: 'Opps..',
                text: err.response.data.message
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .divider {
    background: #E0E0E0;
    height: 1px;
  }
</style>
